import { Box, Card, Chip, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PinkExtraSmallButton from "../../components/customButtons/PinkExtraSmallButton";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../components/customFields/CustomSelect";
import CustomSelectField from "../../components/customFields/CustomSelectField";
import { fetchEnrolledClass } from "../testPrepDashboard/Api/DashboardApi";
import { fDate } from "../../../utils2/formatTime";
import Loader from "../../../SAPPages/components/Loader/Loader";
import NoClasseEnrolledScreen from "./selectedClassDetails/NoClassEnrolledScreen";
import VideocamIcon from "@mui/icons-material/Videocam";
export default function EnrolledClasses() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [selectedOption, setSelectedOption] = useState("upcoming-and-running");
  const [classData, setClassData] = useState([]);
  const [optionData, setOptionData] = useState([
    { id: 1, value: "past", name: "Past Classes" },

    { id: 2, value: "upcoming-and-running", name: "Upcoming & Running Classes" },
  ]);

  const [loading, setLoading] = useState(true);
    const currentDate = new Date().toISOString().split("T")[0];

  const handlefetchEnrolledClass = async (selectedOption) => {
    setLoading(true);
    try {
      const response = await fetchEnrolledClass({
        user_id: parseInt(userId),
 
        class_status: selectedOption,
      });

      if (response.status === 200) {
   setClassData(
  response?.data.sort((a, b) => new Date(a.enrollment_date) - new Date(b.enrollment_date))
);

        setLoading(false);
      } else {
        setClassData([]);
        setLoading(false);
      }
    } catch (error) {
      setClassData([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    handlefetchEnrolledClass(selectedOption);
  }, [selectedOption]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Grid container gap={1} alignItems="center">
          <Box width={22}>
            <img src="/newdashboard/Classrom/solar_book-bold.png" />
          </Box>
          <Typography
            color="#9D0385"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontWeight={400}
          >
            Enrolled Classes
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6} textAlign="end">
        <CustomSelectField
          width={200}
          color="#9D0385"
          fontWeight={700}
          options={optionData}
          getOptionLabel={(opt) => opt?.name}
          getOptionValue={(opt) => opt?.value}
          value={selectedOption}
          onChange={(e) => {
            setSelectedOption(e.target.value);
          }}
        />
      </Grid>

      {loading ? (
        <Grid item xs={12}>
          <Loader text="Loading Classes..." />
        </Grid>
      ) : !loading && classData?.length === 0 ? (
        <Grid item xs={12}>
          {selectedOption === "past" && (
            <NoClasseEnrolledScreen
              text="No Past Classes"
              subText="You haven’t completed any classes yet. Keep learning and exploring to build your skills. Your achievements await!"
            />
          )}

          {selectedOption === "upcoming" && (
            <NoClasseEnrolledScreen
              text="No Upcoming Classes"
              subText="You don’t have any upcoming classes scheduled. Explore our catalog to find courses that match your interests and start your learning journey today."
            />
          )}

          {selectedOption === "upcoming-and-running" && (
            <NoClasseEnrolledScreen
              text="No Upcoming & Running Classes"
              subText="You’re not currently enrolled in any active classes.  Explore our catalog to find courses that match your interests and start your learning journey today."
            />
          )}
        </Grid>
      ) : (
        classData?.map((classItem, index) => {
          
              const total_sessions = classItem?.total_sessions;
  const remaining_sessions = classItem?.remaining_sessions;
  const completedSession = total_sessions - remaining_sessions;

  const completedPercentage =Math.ceil((completedSession / total_sessions) * 100);
          return(
          <Grid item xs={12} mt={1}>
            <Card
              sx={{
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                borderLeft: "3px solid #DA5DC7", // purple left border
                mb: 2,
                p: "15px",
              }}
            >
              <Box display="flex" alignItems="center" mb={2}>
                <Typography
                  color="#9D0385"
                  fontFamily="Inter"
                  fontSize="16px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontWeight={700}
                >
                  {classItem?.class_id?.name}
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} md={2}>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontWeight={300}
                    fontSize="16px"
                  >
                    Start Date
                  </Typography>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="15px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontWeight={400}
                    mt={1.5}
                  >
                    {fDate(classItem?.enrollment_date)}{" "}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={2}>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontWeight={300}
                    fontSize="16px"
                  >
                    Total Sessions
                  </Typography>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="15px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontWeight={400}
                    mt={1.5}
                  >
                    {classItem?.total_sessions}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={2}>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontWeight={300}
                    fontSize="16px"
                  >
                    Remaining Sessions
                  </Typography>
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontSize="15px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontWeight={400}
                    mt={1.5}
                  >
                    {classItem?.remaining_sessions}
                  </Typography>
                </Grid>

                {/* <Grid
                  item
                  xs={12}
                  md={2}
                  sx={{
                    display: {
                      md: "flex",
                    },
                    // Apply these styles only from md upwards:
                    flexDirection: {
                      xs: "row", // default for xs and sm (or any smaller)
                      md: "column", // from md and up
                    },
                    alignItems: {
                      xs: "flex-start", // default for xs and sm
                      md: "center", // from md and up
                    },
                    justifyContent: {
                      xs: "flex-start", // default for xs and sm
                      md: "center", // from md and up
                    },
                  }}
                >
                  <Typography
                    color="#000000"
                    fontFamily="Inter"
                    fontWeight={300}
                    fontSize="16px"
                  >
                    status
                  </Typography>
                  <Chip
                    size="small"
                    label={
                      classItem?.status_of_student === "active"
                        ? "Active"
                        : "Inactive"
                    }
                    sx={{
                      mt: 1.5,
                      px: 1.5,
                      backgroundColor:
                        classItem?.status_of_student === "active"
                          ? "#077E2B1A"
                          : "#FFEBEE",
                      color:
                        classItem?.status_of_student === "active"
                          ? "#077E2B"
                          : "#C62828",
                      fontFamily: "Inter",
                      fontWeight: 700,
                    }}
                  />
                </Grid> */}

                   <Grid
                                    item
                                    xs={12}
                                    md={2}
                                    sx={{
                                      display: {
                                        md: "flex",
                                      },
                                      // Apply these styles only from md upwards:
                                      flexDirection: {
                                        xs: "row", // default for xs and sm (or any smaller)
                                        md: "column", // from md and up
                                      },
                                      alignItems: {
                                        xs: "flex-start", // default for xs and sm
                                        md: "center", // from md and up
                                      },
                                      justifyContent: {
                                        xs: "flex-start", // default for xs and sm
                                        md: "center", // from md and up
                                      },
                                    }}
                                  >
                                    <Typography
                                      color="#000000"
                                      fontFamily="Inter"
                                      fontWeight={300}
                                      fontSize="16px"
                                    >
                                      Attendence Rate
                                    </Typography>
                                    <Typography
                                      color="#000000"
                                      fontFamily="Inter"
                                      fontSize="15px"
                                      lineHeight="100%"
                                      letterSpacing="0px"
                                      fontWeight={400}
                                      mt={1.5}
                                    >
                                      {completedPercentage} %
                                    </Typography>
                                  </Grid>

                <Grid
                  item
                  xs={12}
                  md={4}
                  container
                  gap={1}
                  justifyContent="flex-end"
                  textAlign="end"
                  mt={1.5}
                >
                  <PinkExtraSmallButton
                    buttonTitle="View Class Details"
                    onClick={() =>
                      navigate(`/test-prep/class-details/${classItem?.id}`)
                    }
                  />

                  {currentDate>=classItem?.enrollment_date &&
                    classItem?.class_id?.mode_of_delivery === "online" && (
                      <PinkExtraSmallButton
                        buttonTitle="Join"
                          onClick={() =>
                                    window.open(
                                      classItem?.class_id?.zoom_link,
                                      "_blank",
                                      "noopener,noreferrer"
                                    )
                                  }
                        startIcon={<VideocamIcon />}
                      />
                    )}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        )})
      )}
    </Grid>
  );
}
